/* eslint-disable */
import { useState, useEffect } from "react";
import { initForegroundNotifications } from "./firebase";
import { css, BG, LAYOUT_MAX_W } from "./components";
import Home from "./HomeScreen";
import UnifiedPortal from "./UnifiedPortal";
import Admin from "./Admin";
import Community from "./Community";
import { LanguageProvider } from "./i18n/LanguageContext";

export default function App(){
  const [screen,setScreen]=useState("home");
  const [unifiedInitialRole,setUnifiedInitialRole]=useState("passenger");
  const [communityFocusPostId,setCommunityFocusPostId]=useState("");
  useEffect(()=>{initForegroundNotifications();},[]);
  useEffect(()=>{
    if(typeof window==="undefined")return;
    const params=new URLSearchParams(window.location.search||"");
    const qsScreen=params.get("screen");
    const qsPost=params.get("post");
    if(qsScreen==="community"){
      setScreen("community");
      setCommunityFocusPostId(qsPost||"");
    }
  },[]);

  const goFromHome=(target)=>{
    if(target==="passenger"||target==="driver"){
      setUnifiedInitialRole(target==="driver"?"driver":"passenger");
      setScreen("unified");
      return;
    }
    setScreen(target);
  };

  return(
    <>
      <style>{css}</style>
      <LanguageProvider>
        <div className="root">
          {screen==="home"
            ?<Home go={goFromHome}/>
            :<div style={{maxWidth:LAYOUT_MAX_W,margin:"0 auto",minHeight:"100vh",background:BG}}>
              {screen==="unified"&&<UnifiedPortal initialRole={unifiedInitialRole} onBack={()=>setScreen("home")} onOpenCommunity={()=>setScreen("community")}/>}
              {screen==="community"&&<Community onBack={()=>setScreen("home")} focusPostId={communityFocusPostId}/>}
              {screen==="admin"&&<Admin onBack={()=>setScreen("home")}/>}
            </div>}
        </div>
      </LanguageProvider>
    </>
  );
}
